import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=20a90b55"
import script from "./Plan.ts?vue&type=script&lang=ts&external"
export * from "./Plan.ts?vue&type=script&lang=ts&external"
import style0 from "./plan.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports